import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalComponent {
  open = input.required<boolean>();
  title = input('');
  closeOnBackdrop = input(true);

  closed = output<void>();

  protected onBackdropClick(): void {
    if (this.closeOnBackdrop()) this.onClose();
  }

  protected onClose(): void {
    this.closed.emit();
  }
}
